import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EnquiryModal from "./EnquiryModal";

const heroImages = [
  "https://i.postimg.cc/nzqZKB57/MG-1732.jpg",
  "https://i.postimg.cc/3w44t9Cq/MG-1660.jpg",
  "https://i.postimg.cc/jdB4tWgg/MG-1719-Pano.jpg"
];

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % heroImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section
        className="relative h-[420px] sm:h-[500px] md:h-[620px] overflow-hidden rounded-2xl"
        aria-label="Anestar Boys Lanet – Victory Campus"
      >
        <h1 className="sr-only">Anestar Boys Lanet – Victory Campus</h1>

        {/* Background Images */}
        {heroImages.map((img, idx) => (
          <div
            key={idx}
            className={`absolute inset-0 bg-center bg-cover transition-all duration-[2000ms] ease-in-out ${
              idx === currentIndex
                ? "opacity-100 scale-105 z-10"
                : "opacity-0 scale-100 z-0"
            }`}
            style={{ backgroundImage: `url("${img}")` }}
          />
        ))}

        <div className="absolute inset-0 bg-black/50 z-10" />

        <div
          className={`absolute inset-0 z-20 flex flex-col items-center justify-end text-center px-6 pb-12 md:pb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="mb-3 px-4 py-1 text-xs uppercase tracking-widest bg-white/10 text-white rounded-full">
            Victory Campus
          </span>

          <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-wide drop-shadow-lg">
            Legacy of Excellence
          </h2>

          <p className="mt-4 max-w-2xl text-sm md:text-base text-white/90 leading-relaxed">
            A leading CBC boys school in Lanet, Nakuru County, nurturing
            discipline, leadership, and academic excellence under the Anestar
            Group of Schools.
          </p>

          <div className="mt-5 h-1 w-2/3 max-w-md bg-gradient-to-r from-red-600 via-orange-400 to-yellow-400 rounded-full" />

          {/* CTA Buttons */}
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-6 py-3 rounded-full bg-red-600 hover:bg-red-700 text-white font-semibold transition"
            >
              Enroll Now
            </button>

            <button
              onClick={() => navigate("/about")}
              className="px-6 py-3 rounded-full border border-white/70 text-white hover:bg-white hover:text-black transition"
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      <EnquiryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Hero;
